import { formatDate, formatTime } from "@/helpers/date_helper";

export const DateActionColumn = ({ actionDate = null, actionBy = '', onClick }) => {

    return (
        <div onClick={onClick} style={{ cursor: onClick ? "pointer" : "default" }}>
            <div>
                {formatDate(actionDate)},
                <small className="text-muted">
                    {" "}
                    {formatTime(actionDate)}
                </small>
            </div>
            <p>
                <span>
                    {" "}
                    {actionBy}
                </span>
            </p>
        </div>
    )
}
